import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Tooltip from 'rc-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Card, CardBody, CardImg, CardTitle, Col } from 'reactstrap'

import DefaultImage from 'assets/img/default-image.png'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'

import { assignUserToCourse } from 'store/AllCourses/actions'
import { unAssignUserFromCourse } from 'store/AllCourses/actions'

import './styles/styles.css'
import 'views/pages/LearningPlan/style.css'
import { cloneCourse, deleteCourse } from '../../../store/Course/actions'

function CourseDetails(props) {
  const [showFullDescription, setShowFullDescription] = useState(false)
  const parentUrl = useSelector((state) => state.courses.parentUrl)

  const user = useSelector((state) => state.auth.user)
  const allCourses = useSelector((state) => state.allCourses)
  const language = props.language || {}
  const [colSize, setColSize] = useState('3')
  const toggleShowFullDescription = (e) => {
    e.preventDefault()
    setShowFullDescription(!showFullDescription)
  }

  const dispatch = useDispatch()

  let assignedCourses = []
  let assignedBy = {}
  if (
    allCourses &&
    allCourses.assignedCourses &&
    allCourses.assignedCourses.length
  ) {
    allCourses.assignedCourses.map((item, index) => {
      assignedCourses.push(item.course_id)
      assignedBy[item.course_id] = item.created_by
    })
  }

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 1600) {
        setColSize('3')
      } else {
        setColSize('4')
      }
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  console.log(assignedCourses, 'leart65')

  const cardStatus = () => {
    return assignedCourses.includes(props.courseItem.course_id) ? (
      <span className=' course-status text-nowrap ' style={{ width: '35%' }}>
        {language.courses ? language.courses.enrolled : null}
      </span>
    ) : null
  }
  return (
    <Col xs='12' sm='6' md='4' lg='3' lg={colSize}>
      <Card
        style={{ height: '300px' }}
        className='p-0 shadow'
        key={props.userIndex}
      >
        <Link
          to={`/course/${props.courseItem.course_id}`}
          style={{ height: '100%' }}
        >
          <div
            className={'card-image-box'}
            style={{
              height: '83%',
            }}
          >
            <CardImg
              style={{
                width: '100%',
                position: 'relative',
                objectFit: 'cover',
                height: 'max(100%, 100%)',
                transition: 'all 0.3s',
              }}
              alt='...'
              src={
                props.courseItem.image ? props.courseItem.image : DefaultImage
              }
              top
            />
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                color: '#fff',
              }}
            >
              {cardStatus()}
              <div className={'card-content mb text-sm '}>
                {props.courseItem.description}
              </div>
            </div>
            {<div className={'img-overlay'}></div>}
          </div>
          <CardBody
            className='p-2 px-3 border-top course-details'
            style={{
              height: '17%',
              maxHeight: props.fromSearch ? '180px' : '160px',
              backgroundColor: `${'#fff'}`,
            }}
          >
            <div className='d-flex flex-column justify-content-between pb-0'>
              <div>
                <CardTitle
                  className='my-1 mb-2 d-flex justify-content-between '
                  tag='h3'
                >
                  <span className='course-name'>{props.courseItem.name}</span>
                  {user && user.access == 1 && (
                    <Tooltip
                      placement='right'
                      mouseEnterDelay={0.1}
                      mouseLeaveDelay={0}
                      trigger={['click', 'hover']}
                      overlay={
                        <div className='pb-1'>
                          {!assignedCourses.includes(
                            props.courseItem.course_id
                          ) ? (
                            <p className='text-light p-0 m-0'>
                              {language.courses
                                ? language.courses.enroll_to_the_course
                                : null}
                            </p>
                          ) : (
                            <p className='text-light p-0 m-0'>
                              {language.courses
                                ? language.courses.unenroll_to_the_course
                                : null}
                            </p>
                          )}
                        </div>
                      }
                    >
                      <Button
                        className='btn-icon-only d-flex align-items-center justify-content-center'
                        role='button'
                        outline
                        color={
                          !assignedCourses.includes(props.courseItem.course_id)
                            ? 'info'
                            : 'warning'
                        }
                        size='sm'
                        onClick={(e) => {
                          e.preventDefault()
                          !assignedCourses.includes(props.courseItem.course_id)
                            ? dispatch(
                                assignUserToCourse(props.courseItem.course_id)
                              )
                            : dispatch(
                                unAssignUserFromCourse(
                                  props.courseItem.course_id
                                )
                              )
                        }}
                      >
                        {!assignedCourses.includes(
                          props.courseItem.course_id
                        ) ? (
                          <FontAwesomeIcon
                            className='enroll-icon'
                            icon={faPlus}
                          />
                        ) : (
                          <FontAwesomeIcon
                            className='enroll-icon'
                            icon={faMinus}
                          />
                        )}
                      </Button>
                    </Tooltip>
                  )}
                </CardTitle>
              </div>
            </div>
          </CardBody>
        </Link>
      </Card>
    </Col>
  )
}

export default CourseDetails
